import React from 'react';

export interface DeepLinkingContextType {
    handleDeepLinkingOrRedirectHome: (jobId: string) => Promise<boolean>;
}

export default React.createContext({} as DeepLinkingContextType);